import { KnownCartError } from "@swo/storefront";

export const KNOWN_ERROR_UNKNOWN_ERROR: KnownCartError = { tag: "unknown-cart-error", scope: "top-level" };
